import { render, staticRenderFns } from "./BulkTagUploader.vue?vue&type=template&id=13aaa00c"
import script from "./BulkTagUploader.vue?vue&type=script&lang=js"
export * from "./BulkTagUploader.vue?vue&type=script&lang=js"
import style0 from "./BulkTagUploader.vue?vue&type=style&index=0&id=13aaa00c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports